(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("nary-tree-mab", [], factory);
	else if(typeof exports === 'object')
		exports["nary-tree-mab"] = factory();
	else
		root["nary-tree-mab"] = factory();
})(global, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./lib/nary-tree-mab.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./lib/nary-tree-mab.js":
/*!******************************!*\
  !*** ./lib/nary-tree-mab.js ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// keeping a list of nodes in a map, keyed on the .id property
// to find a node by id look in the node map (.nodes_list)
// to find the children or the parent look in the node in the parent or children
// properties

//TODO: k, max_depth
var NaryTree = exports.NaryTree = function () {
    function NaryTree() {
        var k = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var max_depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        _classCallCheck(this, NaryTree);

        this.k = k;
        this.max_depth = max_depth;
        this.root_id = null;
        this.last_node_id = null;
        this.nodes_list = new Map();
    }

    _createClass(NaryTree, [{
        key: "root",
        value: function root() {
            if (this.root_id === null) {
                return null;
            }
            return this.nodes_list.get(this.root_id);
        }
    }, {
        key: "set_root",
        value: function set_root(node) {
            if (!(node instanceof NaryNode)) {
                throw new Error("set_root expects a NaryNode as paramenter");
            }
            var old_root_id = this.root_id;

            this.root_id = node.id;
            this.nodes_list.set(node.id, node);
        }
    }, {
        key: "create_node",
        value: function create_node(parent_id, data) {
            var _this = this;

            var node = new NaryNode(data, parent_id);
            // no root, so we set this node to be it
            if (this.last_node_id === null) {
                if (parent_id != null) {
                    throw new Error("there is no root defined for this tree, cannot set a parent");
                }
                node.id = 0;
                this.set_root(node);
                this.last_node_id = 0;
            } else {
                node.id = this.last_node_id + 1;
                node.parent_id = parent_id;
                this.last_node_id = node.id;
                this.nodes_list.set(node.id, node);
            }
            node.tree = function () {
                return _this;
            };
            return node;
        }
    }, {
        key: "node",
        value: function node(node_id) {
            if (parseInt(node_id) !== node_id) {
                throw new Error("node_id " + node_id + " must be an integer");
            }
            return this.nodes_list.get(node_id);
        }
    }, {
        key: "remove_node",
        value: function remove_node(node_id) {
            var tree = this;
            var node = this.nodes_list.get(node_id);
            node.get_children().forEach(function (item) {
                tree.remove_node(item.id);
                tree.nodes_list.delete(item.id);
            });
            this.nodes_list.delete(node_id);
        }
    }]);

    return NaryTree;
}();

// NaryNode because lots of other things are called Node


var NaryNode = function () {
    function NaryNode(data) {
        var parent_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        _classCallCheck(this, NaryNode);

        this.id = null;
        this.data = data;
        this.parent_id = parent_id;
        this.children = children;
        this.tree = function () {
            return null;
        }; // set it to a closure around the tree object
    }

    _createClass(NaryNode, [{
        key: "get_children",
        value: function get_children() {
            var _this2 = this;

            return Array.from(this.children, function (node_id) {
                return _this2.tree().node(node_id);
            });
        }
    }, {
        key: "set_children",
        value: function set_children() {
            var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            this.children = children;
        }
    }, {
        key: "set_parent",
        value: function set_parent(parent_id) {
            if (parseInt(parent_id) !== parent_id) {
                throw new Error("parent_id is not an integer");
            }
            this.parent_id = parent_id;
        }
    }, {
        key: "parent",
        value: function parent() {
            if (this.parent_id !== null) {
                return this.tree().node(this.parent_id);
            }
            return null;
        }
    }, {
        key: "data",
        value: function data() {
            return this.data;
        }
    }, {
        key: "set_data",
        value: function set_data(data) {
            this.data;
        }
    }, {
        key: "add_child",
        value: function add_child(data) {
            var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            var child = this.tree().create_node(this.id, data, children);
            this.children.push(child.id);
            return child;
        }
    }, {
        key: "remove_child",
        value: function remove_child(child_id) {
            this.tree().remove_node(child_id);
            this.children = this.children.filter(function (i) {
                return i !== child_id;
            });
        }
    }, {
        key: "path",
        value: function path() {
            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (i) {
                return i.id;
            };

            if (this.parent() !== null) {
                var path_fragment = this.parent().path(callback);
                path_fragment.push(callback(this));
                return path_fragment;
            }
            return [callback(this)];
        }
    }]);

    return NaryNode;
}();

/***/ })

/******/ });
});
//# sourceMappingURL=nary-tree-mab.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/nary-tree-mab/dist/nary-tree-mab.js
// module id = 73
// module chunks = 0